import classNames from 'classnames';
import type { FC, ReactNode } from 'react';

export const Group: FC<{ className?: string; children: ReactNode }> = (
  props,
) => {
  // props
  const { className, children } = props;

  return (
    <section className={classNames('flex flex-col gap-5', className)}>
      {children}
    </section>
  );
};
